// extracted by mini-css-extract-plugin
export default {"component":"InfoBox_component__7Qn2x"};